/**
 * Optional artificial API latency for local development (loading UX preview).
 * Set VITE_DEV_API_LATENCY_MS in .env.mockapi or .env.development.
 * Always 0 when VITE_UI_TEST=true (Playwright / fast CI).
 */
export function readDevApiLatencyMs(): number {
  if (import.meta.env.VITE_UI_TEST === 'true') {
    return 0
  }

  const raw = import.meta.env.VITE_DEV_API_LATENCY_MS
  if (raw === undefined || raw === '') {
    return 0
  }

  const parsed = Number.parseInt(String(raw), 10)
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0
}

/** When true, outbound API calls include artificial delay (see Mirage timing / axios interceptor). */
export function isDevSlowApiPreview(): boolean {
  return readDevApiLatencyMs() > 0
}

export function delayMs(ms: number): Promise<void> {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms)
  })
}
